import Form from "../../componets/Form";

export default function Section3() {
  return (
    <Form />
  );
}
